import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  {
    path: '', //메인 (빈화면)
    loadChildren: () => import('./pages/waiting/waiting.module').then(m => m.WaitingPageModule),
    canActivate: [AuthGuard],
  },
  /**
   * 로그인/가입
   */
  {
    path: 'login', //로그인
    loadChildren: () => import('./pages/account/login/login.module').then(m => m.LoginPageModule),
  },
  {
    path: 'login/naver', //웹 네이버 로그인 리턴 페이지
    loadChildren: () => import('./pages/account/login/login.module').then(m => m.LoginPageModule),
  },
  {
    path: 'login-email', //로그인 이메일
    loadChildren: () => import('./pages/account/login-email/login-email.module').then(m => m.LoginEmailPageModule),
  },
  {
    path: 'sign-up-terms', //이메일 가입시 약관동의
    loadChildren: () => import('./pages/account/sign-up-terms/sign-up-terms.module').then(m => m.SignUpTermsPageModule),
  },
  {
    path: 'sign-up-inner', //이메일 가입시 정보입력
    loadChildren: () => import('./pages/account/sign-up-inner/sign-up-inner.module').then(m => m.SignUpInnerPageModule),
  },
  {
    path: 'sign-up-social', //sns 가입시 닉네임 입력
    loadChildren: () => import('./pages/account/sign-up-social/sign-up-social.module').then(m => m.SignUpSocialPageModule),
  },
  {
    path: 'infor-add', //추가정보 입력
    loadChildren: () => import('./pages/account/infor-add/infor-add.module').then(m => m.InforAddPageModule),
  },
  {
    path: 'password-find', //비밀번호 찾기
    loadChildren: () => import('./pages/account/password-find/password-find-routing.module').then(m => m.PasswordFindPageRoutingModule),
  },
  {
    path: 'password-result', //비밀번호 찾기 결과
    loadChildren: () => import('./pages/account/password-result/password-result-routing.module').then(m => m.PasswordResultPageRoutingModule),
  },
  /**
   * 사용자
   */  
  {
    path: 'user-tabs', //회원:: 메인 탭
    loadChildren: () => import('./pages/user/user-tabs/user-tabs.module').then(m => m.UserTabsPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'casting', //회원:: 최애 캐스팅하기전 최애정보 확인
    loadChildren: () => import('./pages/user/casting/casting.module').then(m => m.CastingPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'friendtalk-ask', //최애에게 채팅 신청
    loadChildren: () => import('./pages/user/friendtalk-ask/friendtalk-ask.module').then(m => m.FriendtalkAskPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'message-detail', //회원:: 채팅 상세
    loadChildren: () => import('./pages/user/message-detail/message-detail.module').then(m => m.MessageDetailPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'message-edit', //회원:: 채팅별 설정
    loadChildren: () => import('./pages/user/message-edit/message-edit.module').then(m => m.MessageEditPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'basic-color', //채팅방 배경 색상 설정
    loadChildren: () => import('./pages/user/basic-color/basic-color.module').then(m => m.BasicColorPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'mediagathering', //회원:: 채팅별 사진/영상 모아보기 (현재 모든 미디어 다보임)
    loadChildren: () => import('./pages/user/mediagathering/mediagathering.module').then(m => m.MediagatheringPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'photovideo-detail', //사진, 영상 상세
    loadChildren: () => import('./pages/user/photovideo-detail/photovideo-detail.module').then(m => m.PhotovideoDetailPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'calendar', //채팅 캘린더
    loadChildren: () => import('./pages/user/calendar/calendar.module').then(m => m.CalendarPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'schedule-write', //채팅 캘린더 쓰기
    loadChildren: () => import('./pages/user/schedule-write/schedule-write.module').then(m => m.ScheduleWritePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'voicemessage-write', //회원:: 음성메시지 신청
    loadChildren: () => import('./pages/user/voicemessage-write/voicemessage-write-routing.module').then(m => m.VoicemessageWritePageRoutingModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'videomessage-write', //회원:: 영상메시지 신청
    loadChildren: () => import('./pages/user/videomessage-write/videomessage-write.module').then(m => m.VideomessageWritePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'friendmanage', //메인에서 최애관리 설정
    loadChildren: () => import('./pages/user/friendmanage/friendmanage.module').then(m => m.FriendmanagePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'givegift', //회원:: 하트 선물하기 (최애 선택가능)
    loadChildren: () => import('./pages/user/givegift/givegift.module').then(m => m.GivegiftPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'givegift-d', //회원:: 최애에게 하트 선물
    loadChildren: () => import('./pages/user/givegift-d/givegift-d.module').then(m => m.GivegiftDPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'profile-edit', //회원:: 프로필 수정
    loadChildren: () => import('./pages/user/profile-edit/profile-edit.module').then(m => m.ProfileEditPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'personal-setting', //회원:: 개인정보 설정
    loadChildren: () => import('./pages/user/personal-setting/personal-setting.module').then(m => m.PersonalSettingPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'password-edit', //비밀번호 변경
    loadChildren: () => import('./pages/user/password-edit/password-edit.module').then(m => m.PasswordEditPageModule),
    canActivate: [AuthGuard],
  },


  {
    path: 'alarm', //회원:: 알람
    loadChildren: () => import('./pages/user/alarm/alarm.module').then(m => m.AlarmPageModule),
    canActivate: [AuthGuard],
  },

  {
    path: 'search', //최애 검색
    loadChildren: () => import('./pages/user/search/search.module').then(m => m.SearchPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'friend-category', //카테고리별 최애
    loadChildren: () => import('./pages/user/friend-category/friend-category.module').then(m => m.FriendCategoryPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'recomfriend', //추천최애
    loadChildren: () => import('./pages/user/recomfriend/recomfriend.module').then(m => m.RecomfriendPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'recommendcode', //추천코드 입력
    loadChildren: () => import('./pages/account/recommendcode/recommendcode.module').then(m => m.RecommendcodePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dealrecord', //회원:: 모달:: 다이렉트메시지 신청현황 상세
    loadChildren: () => import('./pages/user/dealrecord/dealrecord.module').then(m => m.DealrecordPageModule),
    canActivate: [AuthGuard],
  },


  /**
   * 일반
   */
  {
    path: 'notice', //공지사항
    loadChildren: () => import('./pages/user/notice/notice.module').then(m => m.NoticePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'faq', //FAQ
    loadChildren: () => import('./pages/faq/faq.module').then(m => m.FaqPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'inquire', //문의하기 목록
    loadChildren: () => import('./pages/user/inquire/inquire.module').then(m => m.InquirePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'inquire-write', //문의하기 글쓰기
    loadChildren: () => import('./pages/user/inquire-write/inquire-write.module').then(m => m.InquireWritePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'inquire-detail', //문의하기 상세
    loadChildren: () => import('./pages/user/inquire-detail/inquire-detail.module').then(m => m.InquireDetailPageModule),
    canActivate: [AuthGuard],
  },  
  {
    path: 'service', //이용약관
    loadChildren: () => import('./pages/user/terms/service/service.module').then(m => m.ServicePageModule),
  },
  {
    path: 'personal-info', //개인정보 취급방침
    loadChildren: () => import('./pages/user/terms/personal-info/personal-info.module').then(m => m.PersonalInfoPageModule),
  },
  {
    path: 'business-term', //비즈니스 약관
    loadChildren: () => import('./pages/user/terms/business-term/business-term.module').then(m => m.BusinessTermPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'setting', //설정
    loadChildren: () => import('./pages/user/setting/setting.module').then(m => m.SettingPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'storage', //회원:: 보관함
    loadChildren: () => import('./pages/user/storage/storage.module').then(m => m.StoragePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'photovideo-storage-detail', //회원:: 보관함 이미지,영상,음성 상세
    loadChildren: () => import('./pages/user/photovideo-storage-detail/photovideo-storage-detail.module').then(m => m.PhotovideoStorageDetailPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'private-detail', //회원:: 보관함->다이렉트메시지 탭->상세
    loadChildren: () => import('./pages/user/private-detail/private-detail.module').then(m => m.PrivateDetailPageModule),
    canActivate: [AuthGuard],
  },

  /**
   * 비회원
   */
  {
    path: 'visitor-tabs', //비회원:: 메인
    loadChildren: () => import('./pages/visitor/tabs/visitor-tabs.module').then(m => m.VisitorTabsPageModule),
  },
  {
    path: 'visitor-store', //비회원:: 모달:: 하트스토처
    loadChildren: () => import('./pages/visitor/store/visitor-store.module').then(m => m.VisitorStorePageModule),
  },
  {
    path: 'visitor-profile', //비회원:: 최애 프로필 상세
    loadChildren: () => import('./pages/visitor/profile-detail/visitor-profile-detail.module').then(m => m.VisitorProfileDetailPageModule),
  },
  {
    path: 'visitor-detail-my', //비회원:: 내 프로필
    loadChildren: () => import('./pages/visitor/visitor-detail-my/visitor-detail-my.module').then(m => m.VisitorDetailMyPageModule),
  },
  {
    path: 'visitor-alarm', //비회원:: 알람
    loadChildren: () => import('./pages/visitor/alarm/visitor-alarm.module').then(m => m.VisitorAlarmPageModule),
  },
  {
    path: 'visitor-search', //비회원:: 최애 검색
    loadChildren: () => import('./pages/visitor/search/visitor-search.module').then(m => m.VisitorSearchPageModule),
  },
  {
    path: 'visitor-recomfriend', //비회원:: 추천 최애
    loadChildren: () => import('./pages/visitor/recomfriend/visitor-recomfriend.module').then(m => m.VisitorRecomfriendPageModule),
  },
  {
    path: 'visitor-friend-category', //비회원:: 카테고리별 최애
    loadChildren: () => import('./pages/visitor/friend-category/visitor-friend-category.module').then(m => m.VisitorFriendCategoryPageModule),
  },
  {
    path: 'visitor-message-list', //비회원:: 다이렉트메시지 신청 목록
    loadChildren: () => import('./pages/visitor/message-list/visitor-message-list.module').then(m => m.VisitorMessageListPageModule),
  },
  {
    path: 'visitor-friendtalk-ask', //비회원:: 채팅 신청
    loadChildren: () => import('./pages/visitor/friendtalk-ask/visitor-friendtalk-ask.module').then(m => m.VisitorFriendtalkAskPageModule),
  },
  {
    path: 'visitor-casting', //비회원:: 모달:: 셀럽 상세
    loadChildren: () => import('./pages/visitor/casting/visitor-casting.module').then(m => m.VisitorCastingPageModule),
  },

  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '',
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
